import { Typography, Button } from "antd";
import { ArrowLeftOutlined } from "@ant-design/icons";
import { useLocation, useNavigate } from "react-router-dom";
import DynamicCards from "../components/cards/DynamicCards";

const { Title } = Typography;

/*
  Full "View all" page for the dashboard Sticky Notes card.

  The dashboard card (see pages/DynamicCards/index.jsx) renders the notes with a
  display limit (layout="2x2" -> 4 cards). When the user clicks "View all", the
  sticky card navigates here and passes — via router state — the moduleName and
  the exact API request it used. We re-render the SAME sticky list, but:
    • drop the dashboard's display cap (no layout/maxCount) so every note shows
    • bump the request limit so the API returns the full list, not just a page
    • hide the "View all" link (this IS the full page)
*/
export default function StickyNotesFullPage() {
  const navigate = useNavigate();
  const { state } = useLocation();

  // Falls back to sensible defaults if the page is opened directly (no state).
  const moduleName = state?.moduleName || "stickyNotes";
  const title = state?.title || "Sticky Notes";

  // Reuse the dashboard's API call values, but lift the limit so we fetch all.
  const request = {
    ...state?.request,
    params: { ...state?.request?.params, limit: 200, offset: 0 },
  };

  return (
    <div>
      <Button
        type="text"
        icon={<ArrowLeftOutlined />}
        onClick={() => navigate(-1)}
        style={{ marginBottom: 12 }}
      >
        Back
      </Button>


      {/* No layout/maxCount -> the full list; viewAll={false} -> no self-link. */}
      <DynamicCards
        moduleName={moduleName}
        title={title}
        columns={4}
        request={request}
        viewAll={false}
      />
    </div>
  );
}
